/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Harsh Kathiriya",
  logo_name: "Harsh Kathiriya",
  nickname: "HK",
  subTitle:
    "A Data Science enthusiast who always want to explore the new technologies and advancements in the Fields of Data Science, ML and AI and open to work in related opensource projects to build an impact on society",
  resumeLink:
    "https://drive.google.com/file/d/1MLpcXK_bXVjwLk2MUh6okFpOhZOFFfEt/view?usp=sharing",
  portfolio_repository: "https://github.com/harsh9898/",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/harsh9898",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/harsh-kathiriya-895b7b126/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCOhsUGexfE28FIATSDkunYA?view_as=subscriber",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:harsh.kathiriya1111@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/harshkathiriya123/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Machine Learning, Computer Vision, Raspberry Pi, and NLP projects",
        "⚡ Modeling complex health related models for real-time monitoriong using computer vision",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter",
        "⚡ Creating application backend in Vue.js & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying machine learning and deep learning models on AWS and GCP cloud to use on mobile devices",
        ""
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/harsh9898",
    },
    {
      siteName: "leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://leetcode.com/harshk98/",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@harsh.kathiriya1111",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/harshk98",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Indus Institute of Technology and Engineering (Indus University)",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "logo_indus.png",
      alt_name: "IITE",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI, Soft computing etc.",
        "⚡ Apart from this, I have done courses on Python, Web development, and Javascript",
		"⚡ I was coordinator for various i=events hosted in University  ",
      ],
      website_link: "https://indusuni.ac.in/",
    },
	 {
      title: "California State University Sacramento",
      subtitle: "M.S. in Computer Science",
      logo_path: "sac_state_logo.png",
      alt_name: "CSUS",
      duration: "2019 - present",
      descriptions: [
        "⚡ I have studied computer science related subjects like Advanced DBMS, Machine Learning, Distributed Systems, Computer Architecture and Design etc.",
        "⚡ Apart from this, I have done courses on Machine Learning, Python, Deep Learning, and Data Science.",
		"⚡ I was selected fot the  ",
      ],
      website_link: "https://www.csus.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/KKGVXZ9BCBSN",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Intro to Tensorflow for AI, ML, and DL",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/VSCU35NX73E7",
      alt_name: "deeplearning.ai",
      color_code: "#8C151599",
    },
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/255EFM8PSV5H",
      alt_name: "deeplearning.ai",
      color_code: "#8C151599",
    },
    {
      title: "Facial Expression Recognition with Keras",
      subtitle: "- Snehan Kekre",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/AHT8Z5A8RM47",
      alt_name: "Coursera Project Network",
      color_code: "#8C151599",
    },
    {
      title: "The Python Mega Course: Build 10 Real World Applications",
      subtitle: "- Ardit Sulce",
      logo_path: "python_mega.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-edd8386b-f872-489b-912e-b27f2c0db780/",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    /*{
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },*/
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internships and Volunteership",
  description:
    "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    /*{
      title: "Work",
      experiences: [
        {
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - PRESENT",
          location: "Hyderabad, Telangana",
          description:
            "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description:
            "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
      ],
    },*/
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineer Intern - Machine Learning and AI",
          company: "Fanalyze, INC.",
          company_url: "https://www.fanalyze.com/#/",
          logo_path: "fanalyze_logo.png",
          duration: "May 2020 - August 2020",
          location: "Sacramento, California",
          description:
            "I have worked on real-world application. I have developed a cross-platform chatbot applicationm which works on both on Android and iOS using  Flutter, Dialogflow, and APIs. This was an amazing learning hands-on experience. This application will be used by Sacramento Kings. Tools and Technologies used: Dialogflow, Android Studio, Google Cloud, Python ",
          color: "#008000",
        },
        {
          title: "Machine Learning Research Intern",
          company: "Physical Research Laboratory",
          company_url:
            "https://www.prl.res.in/prl-eng/",
          logo_path: "prl_logo.png",
          duration: "Feb 2019 - May 2019",
          location: "Ahmedabad, India",
          description:
            "Developed classification and mapping of lunar basalt for scientists using Machine Learning techniques. Data used for this project are the images captured by M3(Moon Minerology Mapper)- instrument of Chandrayaan-1 (NASA) SVM, K-SVM, KNN, Random Forest, Neural network used for classification. Libraries: Scikit-learn, Tensorflow,NumPy, Pandas, Matplotlib, Seaborn",
          color: "#0071C5",
        },
        {
          title: "Internshala Campuse Ambassador",
          company: "Internshala",
          company_url:
            "https://internshala.com/",
          logo_path: "internshala_logo.png",
          duration: "May 2018 - Aug 2018",
          location: "Work From Home",
          description:
            "Different seminars, lectures and activities were organised by me on behalf of Internshala to educate students about the importance of Internships during any kind of degree. I have done digital Marketing on various social media platforms to make students aware about internships.",
          color: "#87CEEB",
        },
        {
          title: "Software Engineer Intern",
          company: "Softqube Technologies Pvt. Ltd.",
          company_url:
            "https://www.softqubes.com/",
          logo_path: "softqube_logo.png",
          duration: "Jan 2018 - Mar 2018",
          location: "Ahmedabad, India",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#000000",
        },
        
      ],
    },
    {
      title: "Volunteerships",
      experiences: [

        {
          title: "Data Science Club coordinator",
          company: "California State University Sacramento",
          company_url: "https://csus.edu/",
          logo_path: "sac_state_logo.png",
          duration: "Jan 2020 - present",
          location: "Sacramento, California",
          description:
            "Running the club and helping other students to make aware of Data Science and also doing some projects with club members. Sometimes we bring speaker from Data Science industry.",
          color: "#0C9D58",
        },
        {
          title: "Local Hack Day volunteer",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "Dec 2018",
          location: "Ahmedabad, India",
          description:
            "I was a volunteer for the Local Hack Day organised by GitHub. I helped the students to register and help them with technical issues. It was an amazing experience",
          color: "#181717",
        },
        {
          title: "Career Fair Volunteer",
          company: "California State University Sacramento",
          company_url: "https://csus.edu/",
          logo_path: "sac_state_logo.png",
          duration: "November 2019",
          location: "Sacramento, California",
          description:
            "Helped Recruiters and students with thier thing and queries. It was a good experience to talk directly with recruites.",
          color: "#0C9D58",
        },
        {
          title: "Volunteer",
          company: "GirlScript Foundation",
          company_url:
            "https://www.gssoc.tech/index.html#about",
          logo_path: "girlscript_logo.png",
          duration: "Aug 2018",
          location: "Ahmedabad, India",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#FF4500",
        },
      
       
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "harsh_profile.png",
    description:
      "You can message me on any Social media, I will reply within 24 hours. I can help you with ML, AI, Android, and Cloud ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://harshkathiriya98.wordpress.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "1100 Howe Ave Apt 462, Sacramento CA",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/BmbZjkKWHWLT9zk17",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 9168964811 / +91 9898270500",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
